import React from 'react'

import { View, Loader } from '@aws-amplify/ui-react'



import { Location } from '@mytmpvpn/mytmpvpn-common/models/location'
import { useComponentSize } from './ResponsiveSize'


export function Country({ location }: { location: Location }) {
  const componentSize = useComponentSize()
  if (!location) return <Loader variation='linear' />

  return <View style={{ whiteSpace: 'nowrap' }}>
      <img
        alt={location.country}
        src={`/flags/4x3/${location.countryCode}.svg`}
        width="16"
      />{componentSize === 'standard' ? ` ${location.country}` : ''}
  </View>
}

